import { getMessaging, getToken } from "firebase/messaging";
import { befehl } from "../plattform/api";
import { firebaseDienste } from "../plattform/firebase";
import { benachrichtigungenMoeglich, geraetebezeichnungVorschlag } from "../plattform/geraet";

/**
 * Geräteabonnement (ADR-0021, benachrichtigungen.md §2.1): erst nach der Zustimmung der Person über
 * `Notification.requestPermission()`, dann das FCM-Token mit dem `vapidKey` aus `/config.json` und
 * `GeraeteabonnementAnlegen`. Im Gerät stehen nur die Kennung des Abonnements je Konto und ob schon gefragt wurde.
 */
const ABONNEMENT = "dj-abonnement";
const GEFRAGT = "dj-benachrichtigungen-gefragt";

function abonnements(): Record<string, string> {
  try {
    return (JSON.parse(localStorage.getItem(ABONNEMENT) ?? "{}") as Record<string, string>) ?? {};
  } catch {
    return {};
  }
}

/** Hat das Konto auf diesem Gerät ein Geräteabonnement angelegt? */
export function abonniert(uid: string): boolean {
  return !!abonnements()[uid];
}

function merken(uid: string, id: string | null): void {
  const alle = abonnements();
  if (id) alle[uid] = id;
  else delete alle[uid];
  localStorage.setItem(ABONNEMENT, JSON.stringify(alle));
}

/** Zustimmung erfragen (nur wenn der Browser sie noch nicht kennt) und das Geräteabonnement anlegen. */
export async function benachrichtigungenEinschalten(uid: string, geraetebezeichnung = geraetebezeichnungVorschlag()): Promise<string | null> {
  const erlaubnis = Notification.permission === "granted" ? "granted" : await Notification.requestPermission();
  if (erlaubnis !== "granted") return "abgelehnt";
  const { app, konfig } = firebaseDienste();
  const registrierung = await navigator.serviceWorker.ready;
  const token = await getToken(getMessaging(app), {
    serviceWorkerRegistration: registrierung, ...(konfig.vapidKey ? { vapidKey: konfig.vapidKey } : {}),
  });
  const a = await befehl("GeraeteabonnementAnlegen", { Benachrichtigungsadresse: token, "Gerätebezeichnung": geraetebezeichnung });
  const id = a.kennungen["Geraeteabonnement"];
  if (a.ok && id) merken(uid, id);
  return a.ok ? null : a.grund;
}

export async function benachrichtigungenAusschalten(uid: string): Promise<void> {
  const id = abonnements()[uid];
  if (id) await befehl("GeraeteabonnementEntfernen", { "Geräteabonnement": id });
  merken(uid, null);
}

/**
 * Nach der Anmeldung mit Passkey (ADR-0021, `oberflaeche/10`): Hat die Person auf diesem Gerät schon zugestimmt, legt
 * die App das Abonnement ohne Rückfrage an; sonst bittet sie auf diesem Gerät genau einmal um Zustimmung (hat die
 * Person im Browser schon abgelehnt, antwortet er ohne Dialog). Auf einem iPhone ohne Home-Bildschirm fragt sie nicht.
 */
export async function nachDerAnmeldung(uid: string): Promise<void> {
  if (!benachrichtigungenMoeglich() || abonniert(uid)) return;
  if (Notification.permission !== "granted") {
    if (localStorage.getItem(GEFRAGT)) return;
    localStorage.setItem(GEFRAGT, "ja");
  }
  try {
    await benachrichtigungenEinschalten(uid);
  } catch {
    // Ohne Token (z. B. Push-Dienst nicht erreichbar) bleibt das Gerät ohne Abonnement; die Einstellungen bieten es an.
  }
}
